import { ParameterListValueTypeEnumSchema } from "@/Enums/ParameterListValueType";
import { z } from "zod";

export const ReportParameterListValueExecutionDtoSchema = z.object({
    value: z.string().nullable(),
    name: z.string().nullable(),
    type: ParameterListValueTypeEnumSchema.nullable(),
});

export type ReportParameterListValueExecutionDto = z.infer<typeof ReportParameterListValueExecutionDtoSchema>;